import { formatPrice } from "../../../../utils/price.utils";

const CheckoutSummary = ({ checkoutData }) => {
    const summary = checkoutData?.data?.items;
    if (!summary) return null;

    return (
        <>
            {checkoutData?.data?.items.length > 0 && (
                <div className="checkout-left_ck" style={{ paddingRight: 0 }}>
                    <h3 className="Price-Details-font-section">  Price Details ({summary.length}) </h3>
                    <div className="section">
                        <div className="price-summary">
                            <div className="trackvel Totalnormal">
                                <div className="txt_title_cal">Total MRP</div>
                                <div>{formatPrice(checkoutData?.data?.mrp_total)}</div>
                            </div>
                            <div className="trackvel Totalnormal">
                                <div className="txt_title_cal">Product Discount</div>
                                <div style={{ color: "rgb(255, 63, 108)" }}>{formatPrice(checkoutData?.data?.mrp_total - checkoutData?.data?.subtotal)}</div>
                            </div>
                            <div className="trackvel Totalnormal">
                                <div className="txt_title_cal">Order Value</div>
                                <div>{formatPrice(checkoutData?.data?.subtotal)}</div>
                            </div>
                            {checkoutData?.data?.applied_coupon?.length > 0 &&
                                checkoutData.data.applied_coupon.map((coupon, index) => (
                                    <div className="trackvel Totalnormal" key={index}>
                                        <div className="txt_title_cal">
                                            Coupon [{" "}
                                            <span style={{ color: "rgb(255, 63, 108)" }}>
                                                {coupon?.coupon_code}
                                            </span>{" "}
                                            ]
                                        </div>

                                        <div>
                                            <span className="coupon" style={{ color: "rgb(255, 63, 108)" }}>
                                                {formatPrice(coupon?.discount)}
                                            </span>
                                        </div>
                                    </div>
                                ))
                            }
                            <div className="trackvel Totalnormal">
                                <div className="txt_title_cal">Shipping Charges</div>
                                <div>{checkoutData?.data?.shipping_charges === 0 ? 'Free' : formatPrice(checkoutData?.data?.shipping_charges)}</div>
                            </div>

                            <div className="trackvel subtotal-section">
                                <div className="txt_title_cal">
                                    <b> Order Total</b>
                                </div>
                                <div>
                                    {formatPrice(checkoutData?.data?.order_total)}
                                </div>
                            </div>
                            <div className="breaker_global">
                                <hr />
                            </div>
                        </div>
                    </div>

                </div>
            )}
        </>
    );
};

export default CheckoutSummary;
